// A category rendered as "(account_number) name" — shared by the autocomplete
// options and the pre-selected value so both read the same. Falls back to just
// the name when there is no account number (it's optional in QBO, or a
// cleared/optimistic value).
export const formatCategoryLabel = (category?: {
  name?: string;
  account_number?: string | null;
}): string => {
  if (!category) return '';
  return category.account_number
    ? `(${category.account_number}) ${category.name ?? ''}`
    : category.name ?? '';
};
